<template>
    <div>
        <container :active_path="path" :plate="'真会投资'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="姓名">
                            <el-input v-model="form.keyword" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                    <robot-add></robot-add>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="头像" show-overflow-tooltip align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="account" label="账号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="password" label="密码" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
    </div>
</template>

<script>
import Container from '../../components/container.vue'
import RobotAdd from '../../components/robot-add.vue';
export default {
    components: {
        Container, RobotAdd,
    },
    data() {
        return {
            path: '/applet/robot',
            tableData: [],
            pageNo: 1,
            pagesize: 10,
            total: 0,
            form: {
                keyword: '',
            },
        }
    },
    mounted () {
        this.getTableData();
    },
    methods: {
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        getTableData() {
            var params = {
                keyword: this.form.keyword,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getRobotList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        add() {
            
        },
        edit() {
            
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
    },
}
</script>

<style lang="scss" scoped>
.head{
    display: flex;
}
.table-box{
    padding: 10px 0;
}
</style>